var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadableReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3.63636C34.2 3.63636 36 5.27273 36 7.27273V14.8545L33.66 12.7273H24C19.58 12.7273 16 15.9818 16 20V36.3636H4C1.8 36.3636 0 34.7273 0 32.7273V7.27273C0 5.27273 1.8 3.63636 4 3.63636H12.36C13.2 1.52727 15.4 0 18 0C20.6 0 22.8 1.52727 23.64 3.63636H32ZM18 3.63636C16.9 3.63636 16 4.45455 16 5.45455C16 6.45455 16.9 7.27273 18 7.27273C19.1 7.27273 20 6.45455 20 5.45455C20 4.45455 19.1 3.63636 18 3.63636ZM24 40C22.9391 40 21.9217 39.6169 21.1716 38.9349C20.4214 38.253 20 37.3281 20 36.3636V20C20 18 21.8 16.3636 24 16.3636H32L40 23.6364V36.3636C40 38.3818 38.22 40 36 40H24ZM36 25.1455L30.34 20H30V25.4545H36V25.1455Z",
    fill: "#00B0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadableReport);
export default __webpack_public_path__ + "static/media/downloadable-report.9d4269bea52bc57893df2ab51308ea19.svg";
export { ForwardRef as ReactComponent };